<div class="dg-filter dg-filter--string">
  <button
    type="button"
    class="dg-filter_op"
    [class.dg-filter_op--active]="menuOpen"
    (click)="toggleMenu()"
    [attr.aria-label]="label(selectedOperator)"
    title="{{ label(selectedOperator) }}">
    <i class="fas fa-filter"></i>
  </button>

  <input
    type="text"
    class="dg-filter_input"
    [value]="value"
    (input)="onInput($any($event.target).value)" />

    @if (value !== '') {
      <button
        type="button"
        class="dg-filter_clear"
        (click)="clear()"
        aria-label="Clear">
        <i class="fas fa-times"></i>
      </button>
    }

    @if (menuOpen) {
      <ul class="dg-filter_menu">
        @for (op of operators; track op) {
          <li
            class="dg-filter_menu-item"
            [class.dg-filter_menu-item--selected]="op === selectedOperator"
            (click)="selectOperator(op)">
            {{ label(op) }}
          </li>
        }
      </ul>
    }
  </div>
